(()=>{
const MONEY_FIELDS = {
  weekly: [0, 1000],
  price: [0, 100000],
  extras: [0, 100000],
  monthly: [0, 10000],
};

function formNumber(value) {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string' || value.trim() === '') return NaN;
  if (!/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim())) return NaN;
  return Number(value);
}

function cents(value) {
  return Math.round((value + Number.EPSILON) * 100);
}

/**
 * Compare replaced memberships with one shared home setup.
 * Inputs and totals use whole cents; split is rounded to cents. Weekly cost is
 * an unrounded per-adult rate, for the UI to format without changing the total.
 * `monthly` is the whole household's home cost, never a per-person cost.
 */
function estimateHousehold(values) {
  const input = values && typeof values === 'object' ? values : {};
  const numbers = {};
  const invalid = [];
  const people = formNumber(input.people);
  const years = formNumber(input.years);
  const basis = input.basis;

  if (!Number.isInteger(people) || people < 1 || people > 8) invalid.push('people');
  if (basis !== 'individual' && basis !== 'household') invalid.push('basis');
  for (const key of ['weekly', 'years', 'price', 'extras', 'monthly']) {
    if (key === 'years') {
      if (!Number.isInteger(years) || years < 1 || years > 10) invalid.push(key);
      continue;
    }
    const number = formNumber(input[key]);
    const [minimum, maximum] = MONEY_FIELDS[key];
    if (!Number.isFinite(number) || number < minimum || number > maximum ||
        (key === 'price' && (number <= 0 || cents(number) === 0))) {
      invalid.push(key);
    } else {
      numbers[key] = cents(number);
    }
  }
  if (invalid.length) return { valid: false, invalid };

  const multiplier = basis === 'individual' ? people : 1;
  const annualGymCents = numbers.weekly * 52 * multiplier;
  const gymCents = annualGymCents * years;
  const upfrontCents = numbers.price + numbers.extras;
  const homeCents = upfrontCents + numbers.monthly * 12 * years;
  const annualAvoidedCents = annualGymCents - numbers.monthly * 12;

  return {
    valid: true,
    people,
    basis,
    years,
    gym: gymCents / 100,
    home: homeCents / 100,
    saving: (gymCents - homeCents) / 100,
    upfront: upfrontCents / 100,
    split: Math.round(upfrontCents / people) / 100,
    perWeekPerAdult: homeCents / (52 * years * people) / 100,
    breakEven: annualAvoidedCents > 0 ? upfrontCents * 12 / annualAvoidedCents : null,
  };
}


const root=document.querySelector('.cf[data-audience="couples-families"]');
if(root){
 const $=s=>root.querySelector(s);
 const rawLang=document.documentElement.lang||'en';
 const baseLang=rawLang.split('-')[0];
 const dict=(window.BMCouplesAndFamiliesTranslations&&(window.BMCouplesAndFamiliesTranslations[rawLang]||window.BMCouplesAndFamiliesTranslations[baseLang]))||{};
 const t=(key)=>dict[key]||key;
 const form=$('#cf-cost-form');
 const fields=Array.from(form.querySelectorAll('[name]'));
 const result=$('.cf-result');
 let priceState='loading';
 let currency='EUR';
 let lastEstimate=null;
 let lastPriceEach=null;
 let lastSaveAmount=0;
 const presets={two:{people:'2',basis:'individual',weekly:'25'},three:{people:'3',basis:'individual',weekly:'25'}};
 const money=(value,decimals=0)=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:decimals,maximumFractionDigits:decimals}).format(value);
 function updateSticky(){
  const offer=$('#cf-sticky-offer');
  if(!offer)return;
  if(priceState==='ready'&&lastPriceEach!=null){
   offer.innerHTML=lastSaveAmount>0
    ?`${t('GM3 Studio')} ${money(lastPriceEach,0)} · <span class="cf-nowrap">${t('Save {amount}').replace('{amount}',money(lastSaveAmount,0))}</span>`
    :`${t('GM3 Studio')} ${money(lastPriceEach,0)}`;
  }else{
   offer.textContent=t('Shop Gym Monster 3 Studio');
  }
 }
 function render(){
  const values=Object.fromEntries(fields.map(f=>[f.name,f.value]));
  const estimate=estimateHousehold(values);
  lastEstimate=estimate;
  root.querySelectorAll('[data-preset]').forEach(b=>{const p=presets[b.dataset.preset];b.setAttribute('aria-pressed',String(p.people===values.people&&p.basis===values.basis&&Number(p.weekly)===Number(values.weekly)&&values.weekly!==''));});
  root.querySelectorAll('[data-years]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.years)===Number(values.years)&&values.years!=='')));
  $('#cf-weekly-label').textContent=values.basis==='household'?t('Weekly household cost'):t('Weekly cost per adult');
  fields.forEach(f=>{if(f.type!=='hidden')f.setAttribute('aria-invalid',String(!estimate.valid&&estimate.invalid.includes(f.name)));});
  const invalidInputs=!estimate.valid&&estimate.invalid.some(k=>k!=='price');
  $('#cf-cost-error').hidden=!invalidInputs;
  const unavailable=priceState==='unavailable';
  const setupLink=$('#cf-calc-setup');
  if(setupLink){
   setupLink.href=unavailable?$('#cf-product-link').href:'#cf-setup';
   setupLink.innerHTML=unavailable?`${t('Check current packages')} <span aria-hidden="true">↗</span>`:`${t('See what’s included')} <span aria-hidden="true">↓</span>`;
  }
  const resultBuy=$('#cf-result-buy-link');
  if(!estimate.valid){
   result.dataset.state=priceState==='loading'&&!invalidInputs?'loading':'error';
   $('#cf-result-label').textContent=Number(values.people)===1?t('You pay'):t('You each pay');
   $('#cf-result-value').textContent=invalidInputs?t('Check your details'):priceState==='loading'?t('Checking price…'):t('Check current price');
   $('#cf-result-period').textContent=invalidInputs?t('Use zero for costs you will not pay. Adults must be 1 to 8 and years 1 to 10.'):priceState==='loading'?t('Using the current Gym Monster 3 / Studio price.'):t('Current Studio pricing is unavailable. See the product page for current packages.');
   $('#cf-gym-total').textContent=t('Pending');$('#cf-home-total').textContent=t('Pending');
   $('#cf-result-saving').textContent='';
   $('#cf-break-even').textContent='';
   $('#cf-gym-bar').style.transform='scaleX(0)';$('#cf-home-bar').style.transform='scaleX(0)';
   if(resultBuy)resultBuy.hidden=true;
   updateSticky();
   return;
  }
  const r=estimate;
  if(resultBuy)resultBuy.hidden=false;
  result.dataset.state=r.saving>0?'positive':r.saving<0?'negative':'equal';
  $('#cf-result-label').textContent=r.people===1?t('You pay'):t('You each pay');
  $('#cf-result-value').textContent=money(r.perWeekPerAdult,2);
  $('#cf-result-period').textContent=r.people===1
   ?t('a week, over {years} {yearword}.').replace('{years}',r.years).replace('{yearword}',r.years===1?t('year'):t('years'))
   :t('a week, split {n} ways over {years} {yearword}.').replace('{n}',r.people).replace('{years}',r.years).replace('{yearword}',r.years===1?t('year'):t('years'));
  $('#cf-gym-label').textContent=r.basis==='household'?t('One household gym plan'):(r.people===1?t('{n} gym membership'):t('{n} gym memberships')).replace('{n}',r.people);
  $('#cf-gym-total').textContent=money(r.gym,0);
  $('#cf-home-total').textContent=money(r.home,0);
  const max=Math.max(r.gym,r.home,1);
  $('#cf-gym-bar').style.transform=`scaleX(${r.gym/max})`;
  $('#cf-home-bar').style.transform=`scaleX(${r.home/max})`;
  const monthlyOngoing=formNumber(values.monthly)||0;
  $('#cf-result-saving').textContent=r.saving>0
   ?t('{amount} stays in your household over {years} {yearword}.').replace('{amount}',money(r.saving,0)).replace('{years}',r.years).replace('{yearword}',r.years===1?t('year'):t('years'))
   :r.saving<0
   ?t('Your example gym cost is {gym} over {years} {yearword}. Your home setup totals {home}, and it’s yours after that.').replace('{gym}',money(r.gym,0)).replace('{years}',r.years).replace('{yearword}',r.years===1?t('year'):t('years')).replace('{home}',money(r.home,0))
   :t('Even cost in this example, and the machine stays yours.');
  $('#cf-break-even').textContent=(r.breakEven===null||r.breakEven>r.years*12)?'':monthlyOngoing>0
   ?t('Paid off in {months} months, after your ongoing home costs.').replace('{months}',Math.ceil(r.breakEven))
   :t('Paid off in {months} months. After that, every session is free.').replace('{months}',Math.ceil(r.breakEven));
  updateSticky();
 }
 fields.forEach(f=>f.addEventListener('input',render));
 form.addEventListener('submit',e=>e.preventDefault());
 root.querySelectorAll('[data-preset]').forEach(b=>b.addEventListener('click',()=>{Object.entries(presets[b.dataset.preset]).forEach(([key,value])=>form.elements[key].value=value);render();}));
 root.querySelectorAll('[data-years]').forEach(b=>b.addEventListener('click',()=>{form.elements.years.value=b.dataset.years;render();}));
 render();

 const features={
  own:{image:'guided-workout',title:t('A routine that belongs to you.'),body:t('Keep your workouts and progress personal with your own account. Follow guided sessions or build your own workout, then let the next person choose theirs.'),note:t('Unlimited user accounts. Everyone keeps their own programme and history.'),alt:t('A woman choosing a workout on Gym Monster 3’s touchscreen')},
  weight:{image:'digital-weights',title:t('Their weights don’t have to be yours.'),body:t('Change the digital resistance between sets without loading weight plates. Each adult can choose the resistance and movements that suit their own session.'),note:t('Up to 100 kg of digital resistance, in 1 kg steps.'),alt:t('A woman adjusting digital resistance on the Gym Monster 3 touchscreen')},
  together:{image:'shared-training',title:t('Some sessions are better together.'),body:t('Take turns on your own schedule, or explore supported Partner Mode exercises together. A little shared training time, without having to share every goal.'),note:t('Partner Mode workouts are built for two.'),alt:t('Two adults training together on opposite sides of Gym Monster 3')}
 };
 const manifestNode=$('#cf-feature-assets');
 const manifest=manifestNode?JSON.parse(manifestNode.textContent):null;
 const initialImage=$('#cf-feature-image').src;
 const mediaUrl=(name,size)=>manifest?manifest[name][size]:new URL(`${name}-${size}.webp`,initialImage).href;
 const tabs=Array.from(root.querySelectorAll('[data-feature]'));
 function chooseFeature(tab,focus=false){
  const feature=features[tab.dataset.feature];
  tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
  $('#cf-feature-panel').setAttribute('aria-labelledby',tab.id);
  const img=$('#cf-feature-image');img.src=mediaUrl(feature.image,1680);img.srcset=`${mediaUrl(feature.image,840)} 840w, ${mediaUrl(feature.image,1680)} 1680w`;img.alt=feature.alt;
  $('#cf-feature-title').textContent=feature.title;$('#cf-feature-body').textContent=feature.body;$('#cf-feature-note').textContent=feature.note;
  if(focus)tab.focus();
 }
 tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>chooseFeature(tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();chooseFeature(tabs[next],true);}});});

 const isLocal=['localhost','127.0.0.1'].includes(location.hostname);
 const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),8000);
 const routeRoot=window.Shopify?.routes?.root||'/';
 function fetchProduct(handle){
  const endpoint=isLocal?`/api/product/${handle}`:`${routeRoot}products/${handle}.js`;
  return fetch(endpoint,{signal:controller.signal}).then(response=>{if(!response.ok)throw new Error('Catalogue unavailable');return response.json();});
 }
 Promise.all([
  fetchProduct('speediance-gym-monster-3'),
  fetchProduct('speediance-premium-care-2-year-in-home-service-plan').catch(()=>null)
 ]).then(([product,premiumCare])=>{
  const variant=(product.variants||[]).find(v=>v.available&&Number(v.price)>0&&(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
  if(!variant)throw new Error('Studio unavailable');
  const catalogueCurrency=product.currency||window.Shopify?.currency?.active;
  if(!catalogueCurrency)throw new Error('Currency unavailable');
  currency=catalogueCurrency;
  const priceEach=Number(variant.price)/100;
  const wasEach=variant.compare_at_price&&Number(variant.compare_at_price)/100;
  const onSale=wasEach&&wasEach>priceEach;
  form.elements.price.value=priceEach;priceState='ready';
  lastPriceEach=priceEach;lastSaveAmount=onSale?wasEach-priceEach:0;
  const origin=isLocal?'https://speediance.eu':location.origin;
  const productUrl=origin+routeRoot+`products/speediance-gym-monster-3?variant=${encodeURIComponent(variant.id)}`;
  $('#cf-price').textContent=money(priceEach,0);
  $('#cf-price-was').textContent=onSale?money(wasEach,0):'';
  $('#cf-price-save').textContent=onSale?t('Save {amount}').replace('{amount}',money(wasEach-priceEach,0)):'';
  $('#cf-product-link').href=productUrl;
  const payOverTime=$('#cf-pay-over-time');if(payOverTime)payOverTime.href=productUrl;
  const heroBuy=$('#cf-hero-buy');if(heroBuy)heroBuy.href=productUrl;
  const heroSave=$('#cf-hero-save');if(heroSave)heroSave.textContent=onSale?`, ${t('save {amount}').replace('{amount}',money(wasEach-priceEach,0))}`:'';
  const heroPriceClause=$('#cf-hero-price-clause');const heroPriceEach=$('#cf-hero-price-each');
  if(heroPriceClause&&heroPriceEach){heroPriceEach.textContent=money(priceEach/(2*5*52),2);heroPriceClause.hidden=false;}
  const faqPrice=$('#cf-faq-price');if(faqPrice)faqPrice.textContent=t('{price}, once').replace('{price}',money(priceEach,0));
  const resultPrice=$('#cf-result-price');if(resultPrice)resultPrice.textContent=money(priceEach,0);
  const resultWas=$('#cf-result-price-was');if(resultWas)resultWas.textContent=onSale?money(wasEach,0):'';
  const resultSave=$('#cf-result-price-save');if(resultSave)resultSave.textContent=onSale?t('Save {amount}').replace('{amount}',money(wasEach-priceEach,0)):'';
  const resultBuyLink=$('#cf-result-buy-link');if(resultBuyLink)resultBuyLink.href=productUrl;
  const stickyBuy=$('#cf-sticky-buy');if(stickyBuy)stickyBuy.href=productUrl;

  const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
  const careValue=careVariant&&Number(careVariant.price)>0?money(Number(careVariant.price)/100,0):null;
  const tickCareValue=$('#cf-tick-care-value');
  if(tickCareValue)tickCareValue.textContent=careValue?t(': 2-year in-home service plan, valued at {value}').replace('{value}',careValue):t(': 2-year in-home service plan');
 }).catch(()=>{
  priceState='unavailable';form.elements.price.value='';
  $('#cf-price').textContent=t('Check Studio package availability');
  $('#cf-price-was').textContent='';$('#cf-price-save').textContent='';
  const heroSave=$('#cf-hero-save');if(heroSave)heroSave.textContent='';
  const resultPrice=$('#cf-result-price');if(resultPrice)resultPrice.textContent=t('Check current price');
  const resultWas=$('#cf-result-price-was');if(resultWas)resultWas.textContent='';
  const resultSave=$('#cf-result-price-save');if(resultSave)resultSave.textContent='';
 }).finally(()=>{clearTimeout(timer);render();});

 const ratingAbort=new AbortController();const ratingTimer=setTimeout(()=>ratingAbort.abort(),8000);
 fetch(`${routeRoot}products/speediance-gym-monster-3`,{signal:ratingAbort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.text();}).then(html=>{
  const ratingMatch=html.match(/data-rating="([\d.]+)"/);
  const ratersMatch=html.match(/data-raters="(\d+)"/);
  if(!ratingMatch||!ratersMatch)return;
  const rating=Number(ratingMatch[1]).toLocaleString(rawLang,{minimumFractionDigits:1,maximumFractionDigits:1});
  const raters=Math.floor(Number(ratersMatch[1])/100)*100;
  if(!raters)return;
  const ratersText=raters.toLocaleString(rawLang);
  const heroRating=$('#cf-hero-rating'),heroRatingText=$('#cf-hero-rating-text');
  if(heroRating&&heroRatingText){heroRatingText.textContent=t('{rating} · {raters}+ reviews').replace('{rating}',rating).replace('{raters}',ratersText);heroRating.hidden=false;}
  const resultRating=$('#cf-result-rating'),resultRatingText=$('#cf-result-rating-text');
  if(resultRating&&resultRatingText){resultRatingText.textContent=t('{rating} · {raters}+').replace('{rating}',rating).replace('{raters}',ratersText);resultRating.hidden=false;}
  const setupRating=$('#cf-setup-rating'),setupRatingText=$('#cf-setup-rating-text');
  if(setupRating&&setupRatingText){setupRatingText.textContent=t('{rating} · {raters}+').replace('{rating}',rating).replace('{raters}',ratersText);setupRating.hidden=false;}
 }).catch(()=>{}).finally(()=>clearTimeout(ratingTimer));

 const action=$('.cf-mobile-action');const visible=new Map();
 const heroEl=$('.cf-hero');
 const heroBuyEl=$('#cf-hero-buy');
 if('IntersectionObserver' in window){
  const watched=[heroBuyEl,$('.cf-result-buy'),$('.cf-product-copy .cf-actions'),$('.cf-close'),document.querySelector('footer')].filter(Boolean);
  const observer=new IntersectionObserver(entries=>{
   entries.forEach(e=>visible.set(e.target,e.isIntersecting));
   const anyCtaVisible=Array.from(visible.values()).some(Boolean);
   action.hidden=anyCtaVisible;
   root.classList.toggle('cf-cta-in-view',anyCtaVisible);
  },{threshold:.05});
  watched.forEach(e=>observer.observe(e));
  if(heroEl){
   const heroObserver=new IntersectionObserver(entries=>{
    entries.forEach(e=>root.classList.toggle('cf-hero-in-view',e.isIntersecting));
   },{threshold:.05});
   heroObserver.observe(heroEl);
  }
  const teaserWatched=[$('.cf-calculator'),$('.cf-demo .cf-button'),$('.cf-product-copy'),$('.cf-questions')].filter(Boolean);
  if(teaserWatched.length){
   const teaserVisible=new Map();
   const teaserObserver=new IntersectionObserver(entries=>{
    entries.forEach(e=>teaserVisible.set(e.target,e.isIntersecting));
    root.classList.toggle('cf-teaser-off',Array.from(teaserVisible.values()).some(Boolean));
   },{threshold:.05});
   teaserWatched.forEach(e=>teaserObserver.observe(e));
  }
 }
}

(function(){
  var els=document.querySelectorAll('.cf-preset-price');
  if(!els.length)return;
  var cur=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';
  var fmt;
  try{fmt=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cur,currencyDisplay:'narrowSymbol',maximumFractionDigits:0});}catch(e){return;}
  els.forEach(function(el){var amt=Number(el.getAttribute('data-amount'));if(Number.isFinite(amt))el.textContent=fmt.format(amt/100);});
})();

})();
